import { render } from "./virtualrecord.vue?vue&type=template&id=4d3e2b02&scoped=true&ts=true"
import script from "./virtualrecord.vue?vue&type=script&lang=ts"
export * from "./virtualrecord.vue?vue&type=script&lang=ts"

import "./virtualrecord.vue?vue&type=style&index=0&id=4d3e2b02&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3e2b02"]])

export default __exports__